/**
 *
 * @returns {boolean}
 */
const isIEcheck = () => {
  const ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones */
  const isEI = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;

  return isEI;
};

export default isIEcheck;
